import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {BandejaService} from '../../services/bandeja.service';
import {Area} from "../../@pages/usuario-final/tramite/type";

@Component({
    selector: 'app-area-autocomplete',
    templateUrl: './area-autocomplete.component.html',
    styleUrls: ['./area-autocomplete.component.css']
})
export class AreaAutocompleteComponent implements OnInit {

    @Input() control: FormControl = new FormControl('')

    @Input() set label(label: string) {
        this.invalidText = label.includes('*') ? '*' : ''
        this.autoCompleteLabel = label.replace('*', '')
    }

    autoCompleteLabel = ''
    invalidText = ''

    @Input() multiple: Boolean = false

    @Input() showName: Boolean = true

    @Input() placeholder: String = ''
    @Input() inputStyle: string = ''

    @Input() guardarBusqueda: boolean = false

    @Output() onOptionSelected = new EventEmitter<Area>()
    @Output() idArea = new EventEmitter<string>()
    inputControl = new FormControl('')

    options: Area[] = []

    optionSelected: Area;

    loading = false;

    optionsEmpty = false;

    areaSelect: { idArea: number, nombreArea: string } = {idArea: null, nombreArea: ''}

    constructor(
        private _expedienteService: BandejaService
    ) {
    }

    ngOnInit(): void {
        const obtenerArea = localStorage.getItem('busquedaArea')
        if (this.guardarBusqueda && obtenerArea) {
            const nombre = JSON.parse(obtenerArea)
            this.inputControl.setValue(nombre.nombreArea)
            this.control.setValue(nombre.idArea)
        }
        this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
            this.areaSelect.nombreArea = value
            if (this.guardarBusqueda) {
                localStorage.setItem('busquedaArea', JSON.stringify(this.areaSelect))
            }
            if (value == '') {
                return this.options = []
            }

            this.loading = true
            this.optionsEmpty = false;
            this.options = []

            this._expedienteService.buscarArea({descripcionArea: value, page: "1", size: "5"}).then(({list}: any) => {
                this.loading = false
                this.options = list
                this.optionsEmpty = !Boolean(list.length)
            })
        })

        this.control.valueChanges.subscribe(value => {
            this.areaSelect.idArea = value
            if (this.guardarBusqueda) {
                localStorage.setItem('busquedaArea', JSON.stringify(this.areaSelect))
            }
            if (!value) {
                this.inputControl.setValue('');
                this.optionSelected = null
            }
        });
    }

    setOptionSelected(event) {
        if (!event.option.value) {
            this.inputControl.setValue('')
            this.control.setValue(null)
            this.idArea.emit(null)
            return
        }
        this.optionSelected = (<Area>event.option.value)

        this.onOptionSelected.emit(this.optionSelected)
        const {idArea, nombreAsistente, nombre} = (<Area>event.option.value)
        this.idArea.emit('' + idArea)

        if (this.multiple) {
            this.inputControl.setValue('')
        } else {
            this.inputControl.setValue(this.showName ? `${nombreAsistente} - ${nombre}` : nombre)
        }
        this.control.setValue(idArea)

    }

    onFocus($event) {

        this.options = []
        this.optionsEmpty = false;
        //PUSH DATA PRUEBA
        this.inputControl.setValue('')
        this.control.setValue('')
    }

    onFocusOut($event) {
        // this.inputControl.setValue(`${this.optionSelected?.nombreAsistente} - ${this.optionSelected?.nombre}`)
    }


}
